import Tooltip from '@mui/material/Tooltip';
import { StatusState } from '../../Hooks/useBizQuery';
import './biz-icon-button.scss';
import { getIconClassByType, TBizIcon } from './BizIcon';
import { useLegacy } from '../../Hooks/admin/useLegacy';
import { TBizButtonSize } from './BizButton';

type BizIconButtonProps = {
	onClick?: () => void;
	icon: TBizIcon | 'CUSTOM';
	customIcon?: string;
	legacy?: boolean;
	state?: StatusState;
	successIcon?: TBizIcon;
	noBackground?: boolean;
	disabled?: boolean;
	title?: string;
	isLead?: boolean;
	size?: TBizButtonSize;
};

export default function BizIconButton({
	onClick,
	icon,
	customIcon,
	legacy: pLegacy,
	state,
	successIcon,
	noBackground,
	disabled,
	title,
	isLead,
	size = 'MEDIUM',
}: BizIconButtonProps) {
	const legacy = useLegacy(pLegacy);

	const clickHandler = () => {
		if (onClick && !disabled) {
			onClick();
		}
	};

	const getMainClass = () => {
		const baseClasses = `biz-icon-btn${isLead ? ' btn-lead' : ''}${disabled ? ' btn-disabled' : ''} biz-icon-btn--size-${size?.toLowerCase()}`;
		if (legacy) {
			return `admin-icon-btn ${baseClasses}`;
		}
		return `biz-icon-btn ${noBackground ? 'no-background' : ''} ${baseClasses}`;
	};

	const getIconClass = () => {
		if (state === 'LOADING') {
			return 'fad fa-spinner-third fa-spin';
		} else if (state === 'SUCCESS') {
			if (successIcon) {
				return getIconClassByType(successIcon);
			}
			return 'far fa-check';
		} else if (state === 'ERROR') {
			return 'fal fa-exclamation-triangle';
		} else if (icon === 'CUSTOM') {
			return customIcon ?? '';
		} else {
			return getIconClassByType(icon);
		}
	};

	if (legacy) {
		return <i className={`${getMainClass()} ${getIconClass()}`} onClick={clickHandler} title={title}></i>;
	}

	if (getIconClass().includes('material-symbols-outlined')) {
		const iconParts = getIconClass().split(' ');
		return (
			<Tooltip title={title}>
				<span className={getMainClass()} onClick={clickHandler}>
					<span className={iconParts[0]}>{iconParts[1]}</span>
				</span>
			</Tooltip>
		);
	}

	return (
		<Tooltip title={title}>
			<span className={getMainClass()} onClick={clickHandler}>
				<i className={getIconClass()}></i>
			</span>
		</Tooltip>
	);
}
